import { IInventoryPage } from '../../../inventory-page.interface';


export const RESEARCH_TRADEMARK_TM_SEARCH_PAGE: IInventoryPage = {
	'route': '/research/trademark/tm-search',
	'title': 'TM Search',
	'uiReference': [
		'Trademark search',
		'Enter a trademark name',
		'Enter the phrase you want to check',
		'Trademark status totals',
		'Search type',
		'Trademark name or phrase',
		'/ characters',
		'Search',
		'Add to watchlist',
		'Advanced options',
		'Refine search',
		'Limit results by jurisdiction, classification, status, or filing dates.',
		'Reset options',
		'Trademark offices',
		'Select the jurisdictions to include.',
		'Nice classes',
		'Choose relevant goods and service classes.',
		'Status',
		'Include the trademark states you need to review.',
		'Date ranges',
		'Filter by application or registration period.',
		'Application',
		'Registration',
		'Start with a name',
		'Check a trademark before you use it',
		'Search international trademark records, inspect status and ownership details, and narrow the results with advanced filters.',
		'Search results',
		'Trademarks',
		'Filed',
		'Registered',
		'Ended',
		'Expired',
		'Filter results',
		'Filter displayed results',
		'Refine the current result set without running another search.',
		'Clear filters',
		'TM Offices',
		'Nice Class',
		'Legal notice: This is not legal advice. Each user remains responsible for verifying trademark information and determining whether a mark is safe to use.',
		'Loading...',
		'Sorry, there was an internal error. Please contact support.',
		'Rows per page',
		'Close trademark details',
		'Add to Watchlist',
		'Search Applicant',
		'View',
		'TM Name',
		'Applicant',
		'Office',
		'filed',
		'registered',
		'Number',
		'Enter a page number',
		'Go to page',
		'Page number'
	],
	'sources': [
		'apps/flying-projects/frontend/webapp/src/app/pages/research/trademark/trademark-routing.module.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/trademark/tm-search/tm-search.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/trademark/tm-search/tm-search.component.html',
		'apps/flying-projects/frontend/webapp/src/app/components/inform-cards/api-loading-card/api-loading-card.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/components/inform-cards/api-loading-card/api-loading-card.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/trademark/shared-components/tm-table/tm-table.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/trademark/shared-components/tm-table/tm-table.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/trademark/shared-components/tm-details/tm-detail.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/trademark/shared-components/tm-details/tm-detail.data.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/trademark/shared-components/tm-details/tm-detail.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/trademark/shared-components/tm-pagination/tm-pagination.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/trademark/shared-components/tm-pagination/tm-pagination.component.html'
	],
	'aliases': []
};
